import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { BoardRoutingModule } from './board-routing.module';
import { BoardDashboardComponent } from './board-dashboard/board-dashboard.component';
import { NextAppointmentComponent } from './components/next-appointment/next-appointment.component';
import { BoardService } from './board.service';
import { BoardAddFileDialogComponent } from './dialog/board-add-file-dialog/board-add-file-dialog.component';
import { MaterialModule } from '../../material.module';
import { FileService } from '@shared/_services/file.service';
import { BoardListComponent } from './board-list/board-list.component';

const COMPONENTS: any[] = [
  BoardAddFileDialogComponent,
  BoardDashboardComponent,
  BoardListComponent,
  NextAppointmentComponent,
];
const COMPONENTS_DYNAMIC: any[] = [];

@NgModule({
  imports: [SharedModule, BoardRoutingModule, MaterialModule, ...COMPONENTS, ...COMPONENTS_DYNAMIC],
  providers: [BoardService, FileService],
  exports: [NextAppointmentComponent],
})
export class BoardModule {}
